<script setup>
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";
  import {mobility} from "@pages/Patientinput/Enums.js";
  import {MedCheckbox, MedFormField, MedLabel} from "@pharma4u/medicheck-components";

  defineOptions({name: "PatientinputComponentStepMobility"});

  defineProps({
    form: {
      type: Object,
      required: true,
    },
  });
</script>

<template>
  <PatientinputComponentStep title="Mobilität" :test-id="getTestId()">
    <p>
      <span v-if="form.masterdata.patient.gender === 'female'">Die Patientin</span>
      <span v-else>Der Patient</span>
      benutzt bzw. ist:
    </p>

    <MedFormField v-for="(attribute, index) in mobility" :key="index" orientation="horizontal" size="mobile">
      <MedCheckbox
        v-model="form.circumstances.attributes[attribute.key]"
        variant="primary"
        :data-test="getTestId(`mobility-step-${index}-checkbox`)"
      />

      <MedLabel>{{ attribute.titleCarer }}</MedLabel>
    </MedFormField>
  </PatientinputComponentStep>
</template>
